import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface SkipLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

const SkipLink: React.FC<SkipLinkProps> = ({ 
  href, 
  children, 
  className 
}) => {
  return (
    <motion.a
      href={href}
      className={cn(
        "absolute left-4 top-4 z-50 -translate-y-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-lg transition-transform duration-200 focus:translate-y-0 focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2",
        className
      )}
      initial={{ y: -100 }}
      whileFocus={{ y: 0 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.a>
  );
};

export default SkipLink;
